export const marginsClassNames = 'px-12 not-print:max-desktop:px-4';
export const marginsSecondaryClassNames = 'px-12 not-print:max-desktop:px-0';
export const linkClassNames = 'text-accent font-medium border-b border-transparent hover:border-current transition-colors';
